/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { PaginaDocument, TecnologiaDocument, TecnologieDocument } from '@gql/graphql'
import { TecnologieDetailTemplate } from '@components/templates'

const ProgettoDetail = ({ pagina, tecnologia }) => (
  <TecnologieDetailTemplate pagina={pagina} tecnologia={tecnologia} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { tecnologie },
  //   } = await client.query({
  //     query: TecnologieDocument,
  //   })

  //   tecnologie?.forEach((x) => paths.push({ params: { slug: x.slug }, locale: locale }))
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/azienda/tecnologie/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { tecnologia },
    } = await client.query({
      query: TecnologiaDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    if (!tecnologia) {
      return {
        notFound: true,
      }
    }

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        chiave: 'tecnologia-detail',
        preview,
        contentTypeId: tecnologia.model,
        objectId: tecnologia.pk,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { tecnologia, pagina },
      revalidate: 60 * 20,
    }
  },
  '/azienda/tecnologie/[slug]'
)

export default ProgettoDetail
